export default __webpack_public_path__ + "static/media/info.5cdd9e4c.svg";